__turbopack_context__.v({
  "className": "noto_sans_sc_d92395de-module__fCCOHW__className",
  "variable": "noto_sans_sc_d92395de-module__fCCOHW__variable",
});
